import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SESSION_COOKIE_PATH } from '@constants';
import { SessionCookies } from '@enums';
import { RolesStorageService } from '@services';

/** Owns the client-side session: the one place that knows what ending it clears. */
@Injectable({
  providedIn: 'root',
})
export class SessionService {
  constructor(
    private cookieService: CookieService,
    private rolesStorageService: RolesStorageService,
  ) {}

  /** Deletes the session cookies (on the path they were set with) and the stored roles. */
  public clear(): void {
    this.cookieService.delete(SessionCookies.accessToken, SESSION_COOKIE_PATH);
    this.cookieService.delete(SessionCookies.userName, SESSION_COOKIE_PATH);
    this.cookieService.delete(
      SessionCookies.needsPasswordChange,
      SESSION_COOKIE_PATH,
    );
    this.cookieService.delete(SessionCookies.hidePrices, SESSION_COOKIE_PATH);
    this.rolesStorageService.clear();
  }
}
